<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>Privacy Policy</h1>

        </div>
    </div>
</div>

<div class="el-blog-single-wrapper">
    <div class="container">
        <div class="row gy-4">
            <div class="col-lg-12 col-md-12">

                <div class="el-inner-blog-box el-blogsingle-comment-box el-blgs-comments-wrapper">

                    <div class="el-blgs-comments">


                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>Thank you for choosing PowerPerp. Your privacy is important to us.
                                    This Privacy Policy explains
                                    how we collect, use, and
                                    protect your personal information, as well as the choices available to you.
                                </h5>

                            </div>
                            <div class="el-blgs-cmt-name">
                                <h5>1. Information Usage

                                </h5>

                            </div>
                            <p class="el-para">We may use your contact details to share important updates, new features,
                                offers, and service-related notifications. You
                                can opt out of promotional emails at any time; however, essential account-related
                                messages may still be sent.</p>

                        </div>
                    </div>
                    <div class="el-blgs-comments ">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>2. Profile Information

                                </h5>

                            </div>
                            <p class="el-para">Your profile data may be used to personalise your experience within
                                PowerPerp and may be visible to other users for
                                relevant service functionality.

                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments ms-0">

                        <div class="el-blgs-cmts ">
                            <div class="el-blgs-cmt-name">
                                <h5>3. Aggregate Data

                                </h5>

                            </div>
                            <p class="el-para">We may analyse aggregated or anonymised data (such as activity patterns)
                                to improve platform performance, optimise
                                features, and support business insights. This data is not personally identifiable.

                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments ms-0">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>4. Third-Party Access

                                </h5>

                            </div>
                            <p class="el-para">If you log in via platforms like Google or Facebook, we may request
                                access to basic public information such as your name
                                and email address. Your data on those platforms remains subject to their respective
                                privacy policies.

                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>5. Cookie Policy


                                </h5>

                            </div>
                            <p class="el-para">We use cookies to store certain preferences and collect insights to
                                enhance user experience. These cookies help us
                                remember you, improve site functionality, and tailor content to your interests.

                            </p>

                        </div>
                    </div>
                    <div class="el-blgs-comments">

                        <div class="el-blgs-cmts">
                            <div class="el-blgs-cmt-name">
                                <h5>6. Content Usage


                                </h5>

                            </div>
                            <p class="el-para">All content on the PowerPerp website or app is protected. No material may
                                be copied, reproduced, republished, uploaded,
                                posted, transmitted, or distributed in any form without prior written permission from
                                PowerPerp.<br>
                                By continuing to use PowerPerp, you agree to this policy.


                            </p>

                        </div>
                    </div>

                </div>

            </div>

        </div>
    </div>
</div>